import React, { useState } from "react";
import { Pagination } from "antd";
import { useSelector } from "react-redux";

const PaginationTwo = ({pageNo, onChangeFunc}) => {
  const trendingState = useSelector(state=>state.trending);
  const handleChange = (key) => {
    if(key ==='plus'){
      onChangeFunc(pageNo+1)
    }else{
      onChangeFunc(pageNo-1)
    }
  };

  return (
   <>
   <div style={{display:'flex', justifyContent:'end', fontWeight:'300',fontSize:'16px', alignItems:'center'}}>
    {pageNo==0 && <span style={{fontSize:'24px', cursor:'notAllowed', color:'#BFBFBF',display:'flex', alignItems:'center'}} ><i className="fa fa-angle-left"></i><span  style={{fontSize:'18px'}}>&nbsp;Previous</span></span>}{pageNo > 0 && <span style={{fontSize:'24px', cursor:'pointer', color:'#5C667B',display:'flex', alignItems:'center'}} onClick={()=>handleChange("minus")}><i className="fa fa-angle-left"></i><span  style={{fontSize:'18px'}}>&nbsp;Previous</span></span>}
    &nbsp;&nbsp;
    {/* <span style={{fontSize:'16px', color:'#5C667B'}}>{pageNo+1}</span> */}
    &nbsp;&nbsp;
    {trendingState.isNext && <span style={{fontSize:'24px', cursor:'pointer', color:"#5C667B",display:'flex', alignItems:'center'}} onClick={()=>handleChange('plus')}><span style={{fontSize:'18px'}}>Next&nbsp;</span><i className="fa fa-angle-right"></i></span>}
    {!trendingState.isNext &&<span style={{fontSize:'24px', cursor:'notAllowed', color:"#BFBFBF",display:'flex', alignItems:'center'}} ><span style={{fontSize:'18px'}}>Next&nbsp;</span><i className="fa fa-angle-right"></i></span>}
   </div>
   </>
  );
};

export default PaginationTwo;